import React from "react";
import PropTypes from "prop-types";
import RoleRoute from "./RoleRoute";

function AgentRoute({ ...rest }) {
  return <RoleRoute {...rest} requiredRoles={["orgAgent"]} />;
}

export default AgentRoute;
